import github from '../../assets/MyGithubIcons/github-mark.svg';
import figma from '../../assets/MyGithubIcons/Figma-Logo.png';
import state from '../../assets/MyGithubIcons/State.jpg';
import rps from '../../assets/MyGithubIcons/RPS.jpg';
import eas from '../../assets/MyGithubIcons/Etch-A-Sketch.jpg';

const contents = [
    {
        icon: github,
        text: 'You can see all of the documentation for this site at my GitHub by clicking on the icon to the left. You might see that I have a great skill when it comes to commit titles and git management. Warning, some of the below examples are rudimentary and old. ',
        href: 'https://github.com/esmodea/MyPortfolio'
    },
    {
        icon: figma,
        text: 'On the right is a link to my Figma where you can see the effort I spent designing this site. Below here is multiple previous noteworthy sites that I’ve built in the past.',
        href: 'https://www.figma.com/file/MQHND4jGeub72LRDy3ggAg/Portfolio-Design?node-id=0%3A1&t=OvcpksRYvVM2l2pt-1'
    },
    {
        icon: state,
        text: 'This is a site that I didn’t design, the link goes to a copy of the site for an example. While I did not build that copy I have coded this site from the ground up as part of my education at BloomTech.',
        href: 'https://advanced-state-wheel.herokuapp.com/'
    },
    {
        icon: rps,
        text: 'Here is my first real JavaScript application. I keep it here because I remember it fondly.',
        href: 'https://esmodea.github.io/RockPaperScissors/'
    },
    {
        icon: eas,
        text: 'This one is a neat little Etch-A-Sketch tool that lets you choose the canvas size. It darkens each pixel by a certain amount upon mouse over. ',
        href: 'https://esmodea.github.io/Etch-A-Sketch/'
    }
];

export default contents;